import { notificationUnreadSchema } from '@fluxus/shared';
import { useQuery } from '@tanstack/react-query';
import { Bell } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';
import { useAuth } from '@/lib/auth/session';

export const NOTIFICATIONS_PATH = '/notificacoes';
export const notificationsKey = ['notifications'] as const;
export const unreadKey = [...notificationsKey, 'unread'] as const;

/** Sino do topo com o contador de não lidas (T-113d, RF-42). Leva à central de notificações. */
export function NotificationBell() {
  const { client } = useAuth();
  const unread = useQuery({
    queryKey: unreadKey,
    queryFn: ({ signal }) =>
      client.request('/me/notifications/unread-count', { schema: notificationUnreadSchema, signal }),
    refetchInterval: 60_000,
    // Falha do contador não atrapalha o topo: o sino aparece sem o número.
    meta: { handlesError: true },
  });
  const count = unread.data?.unread ?? 0;
  const label = count
    ? `Notificações: ${count === 1 ? '1 não lida' : `${count > 99 ? 'mais de 99' : count} não lidas`}`
    : 'Notificações';
  return (
    <Tooltip content={label}>
      <Button asChild variant="ghost" size="icon" className="relative">
        <Link to={NOTIFICATIONS_PATH} aria-label={label}>
          <Bell aria-hidden />
          {count ? (
            <span
              aria-hidden
              className="absolute -top-0.5 -right-0.5 flex h-4.5 min-w-4.5 items-center justify-center rounded-full bg-status-red-fg px-1 text-[0.625rem] leading-none font-bold text-background tabular-nums ring-2 ring-background"
            >
              {count > 99 ? '99+' : count}
            </span>
          ) : null}
        </Link>
      </Button>
    </Tooltip>
  );
}
